import { useStoreCreateDailyMenu } from '../../pages/daily/create/hooks/useStoreCreateDailyMenu'

export const useRenderPrice = () => {
  const store = useStoreCreateDailyMenu()

  const renderPriceWithStoreCurrency = (price: string): string | null => {
    if (price === '' || price === null || price === undefined) {
      return null
    }

    const currencySymbol = store.currencies.find((currency) => {
      return currency.id === store.settingsForm.currencyId.value
    })?.symbol

    const fractionDigits: number = currencySymbol === 'Ft' ? 0 : 2
    const value = parseFloat(price as string).toFixed(fractionDigits)

    return `${value} ${currencySymbol}`
  }

  const renderPriceWithGivenCurrency = (
    price: string,
    currencySymbol: string
  ): string | null => {
    if (price === '') return null

    const fractionDigits: number = currencySymbol === 'Ft' ? 0 : 2
    const value = parseFloat(price as string).toFixed(fractionDigits)

    return `${value} ${currencySymbol}`
  }

  return { renderPriceWithStoreCurrency, renderPriceWithGivenCurrency }
}
